import * as yup from 'yup';

export const emailValidation = yup
    .string()
    .email('INVALID_EMAIL')
    .max(75, 'EMAIL_TOO_LONG')
    .required('FIELD_CANNOT_BE_EMPTY');

export const phoneValidation = yup
    .string()
    .min(3, 'PHONE_NUMBER_IS_TOO_SHORT')
    .max(15, 'PHONE_NUMBER_IS_TOO_LONG')
    .required('FIELD_CANNOT_BE_EMPTY');

export const firstNameValidation = yup
    .string()
    .max(50, 'FIRST_NAME_TOO_LONG')
    .required('FIELD_CANNOT_BE_EMPTY');

export const lastNameValidation = yup
    .string()
    .max(50, 'LAST_NAME_TOO_LONG')
    .required('FIELD_CANNOT_BE_EMPTY');

export const optionalSelect = yup.object({
    key: yup.string().optional(),
    label: yup.string().optional(),
    value: yup.string().optional(),
});

export const requiredSelect = yup
    .object({
        key: yup.string().required('FIELD_CANNOT_BE_EMPTY'),
        label: yup.string().required('FIELD_CANNOT_BE_EMPTY'),
        value: yup.string().required('FIELD_CANNOT_BE_EMPTY'),
    })
    .typeError('FIELD_CANNOT_BE_EMPTY')
    .required('FIELD_CANNOT_BE_EMPTY');

export const validationMessages = {
    FIELD_CANNOT_BE_EMPTY: 'Field cannot be empty',
};

export const requiredSelectV2 = yup
    .object({
        label: yup.string().required(validationMessages.FIELD_CANNOT_BE_EMPTY),
        value: yup.string().required(validationMessages.FIELD_CANNOT_BE_EMPTY),
    })
    .required(validationMessages.FIELD_CANNOT_BE_EMPTY);
